import Container from '@mui/material/Container';

export default function MemrePageContainer({ children }) {
  return (
    <Container maxWidth="lg" fixed={true} sx={{ mx: 'auto', mb: 4 }}>
      {children}
    </Container>
  );
}
